import type { SizeRow } from "@/types";

export const letterSizeGuide: SizeRow[] = [
  { size: "PP", bust: "82 cm", waist: "62 cm", hip: "88 cm", length: "106 cm" },
  { size: "P", bust: "86 cm", waist: "66 cm", hip: "92 cm", length: "107 cm" },
  { size: "M", bust: "90 cm", waist: "70 cm", hip: "96 cm", length: "108 cm" },
  { size: "G", bust: "96 cm", waist: "76 cm", hip: "102 cm", length: "109 cm" },
  { size: "GG", bust: "102 cm", waist: "82 cm", hip: "108 cm", length: "110 cm" },
];

export const numberSizeGuide: SizeRow[] = [
  { size: "36", bust: "82 cm", waist: "62 cm", hip: "88 cm", length: "98 cm" },
  { size: "38", bust: "86 cm", waist: "66 cm", hip: "92 cm", length: "99 cm" },
  { size: "40", bust: "90 cm", waist: "70 cm", hip: "96 cm", length: "100 cm" },
  { size: "42", bust: "94 cm", waist: "74 cm", hip: "100 cm", length: "101 cm" },
  { size: "44", bust: "100 cm", waist: "80 cm", hip: "106 cm", length: "102 cm" },
  { size: "46", bust: "106 cm", waist: "86 cm", hip: "112 cm", length: "103 cm" },
];

export const sizeGuideNote =
  "As medidas são aproximadas e podem variar de acordo com a modelagem da peça.";